import React, { useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { Editor as TinyMCEEditor } from "tinymce";
import styled from "styled-components";

const EditorWrapper = styled("div")`
  .tox-tinymce {
    border-radius: 3px;
  }
`;

const editorHeight = 500;

export const DefaultEditor: React.FC<{
  value?: string;
  onChange: (a: string, editor: TinyMCEEditor) => void;
}> = ({ value, onChange }) => {
  const [editorLoading, setEditorLoading] = useState(true);

  return (
    <EditorWrapper>
      {editorLoading && (
        <div style={{ height: editorHeight }}>Indlæser tekstbehandling!</div>
      )}
      <Editor
        tinymceScriptSrc="/dist/tinymce/tinymce.min.js"
        initialValue="<p>This is the initial content of the editor.</p>"
        onEditorChange={onChange}
        value={value}
        onInit={() => {
          setEditorLoading(false);
        }}
        init={{
          link_target_list: false,
          branding: false,
          height: editorHeight,
          menubar: false,
          language: "da",
          skin: "tinymce-5",
          block_formats: "Paragraph=p; Header 2=h2; Header 3=h3",
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            //"media",
            //"table",
            "preview",
            //"help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic superscript | alignleft aligncenter " +
            "alignright alignjustify | link | bullist numlist outdent indent | " +
            "removeformat | fullscreen",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
          paste_postprocess: (plugin, args) => {
            // Select all elements within the pasted content node
            const elements = args.node.querySelectorAll("*");
            elements.forEach((element) => {
              (element as HTMLElement).style.fontSize = "16px";
            });

            args.node.querySelectorAll("img").forEach((img) => {
              img.remove();
            });

            // Set the font size for the root node as well
            (args.node as HTMLElement).style.fontSize = "16px";
          },
        }}
      />
    </EditorWrapper>
  );
};
